import { Box } from "@mui/material";
import { LabelValueForTags } from "components/ui/atoms/LabelValue";
import ObjectChip from "../components/ObjectChip";
import { getCommons } from "./fieldConverterHelpers";

export const PrimaryKeyRelatedFieldView = ({ field, value }) => {
  return (
    <LabelValueForTags
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      Tags={[
        <ObjectChip
          objId={value}
          modelName={field.subModel}
          forceLoad={true}
        />,
      ]}
      isMissing={value === undefined || value === null}
    />
  );
};

const getChoiceOption = (value, field) => {
  if (value === undefined || value === null || value.toString().trim() === "")
    return null;
  if (!field.choices) {
    return null;
  }
  const choice = field.choices.find((c) => c.value === value);
  if (!choice) {
    return null;
  }
  return choice;
};

const PrimaryKeyRelatedFieldCell = ({ value, colDef, row }) => {
  if (!value) return "";

  if (!colDef._meta.field.subModel) return value;

  const choiceOption = getChoiceOption(value, colDef._meta.field);

  const props = choiceOption?.obj
    ? { obj: choiceOption.obj }
    : { objId: value, objDisplay: row[`_${colDef.field}_display`] };

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <ObjectChip modelName={colDef._meta.field.subModel} {...props} />
    </Box>
  );
};

export const primaryKeyRelatedFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "singleSelect",
    renderCell: PrimaryKeyRelatedFieldCell,
    display: "flex",
    align: field.align || "center",
    valueOptions: field.choices || [],
    width: field.width || (field.choices ? 150 : 90),
  };
};
